import {EdcUiThemeConfig} from './edc-ui-theme-config';

export const SOVITY_THEME: EdcUiThemeConfig = {
  theme: 'theme-sovity',
  brandFaviconSrc: '/assets/images/logo.svg',
  brandLogoSrc: '/assets/images/logo_with letters.png',
  brandLogoStyle: 'width: 70%;',
};

export const MDS_THEME: EdcUiThemeConfig = {
  theme: 'theme-mds',
  brandFaviconSrc: '/assets/images/mds_favicon.ico',
  brandLogoSrc: '/assets/images/mds_logo.svg',
  brandLogoStyle: 'height: 57px; margin-top: 5px; margin-left: 5px;',
};
